import './lib/jquery'

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.getElementsByClassName('js-gba-navigations-toggle')
  let ariaValue = toggle[0].getAttribute('aria-expanded')
  const navigation = document.getElementsByClassName('js-gba-header__navigations')[0]
  const top = window.document.getElementsByClassName('gba-header')[0].offsetHeight
  toggle[0].addEventListener('click', () => {
    ariaValue = !(ariaValue)
    toggle[0].setAttribute('aria-expanded', ariaValue)
    if (ariaValue) {
      navigation.style.cssText = `display: block; width: 100%;
                                  height: 100%; position: fixed; left: 0; top: ${top - 1}px;
                                  z-index: 99; overflow-y: scroll`
      $('body').css('overflow', 'hidden')
    } else {
      navigation.removeAttribute('style')
      $('body').css('overflow', 'auto')
    }
  })
})
